import $ from 'jquery';
import {isEnterEvent, fitText, shuffleArray, swapInArray} from "./playUtil.es6";
import Texter from "./texter.es6";
import 'jquery.hotkeys';
import './../lib/jquery/jquery.textchange.js';
import PlayProgressBar from "./playProgressBar.es6";

require('jsrender')($);

const QUESTION_TEMPLATE = $.templates(`
<div class="play-card-stack__card">
    <div class="play-card-stack__card-side {{if image && text}}play-card-stack__card-side--image-and-text{{/if}} play-card-stack__card-face">
        {{if image}}<div class="play-card-stack__card-image"><img alt="" src="{{attr:image}}" data-fitimage style="display: none;"></div>{{/if}}
        {{if text}}<div class="play-card-stack__card-text"><div class="fl-tt-{{: textType}}" data-fittext>{{if textType == 'html}}{{: text}}{{else}}{{> text}}{{/if}}</div></div>{{/if}}
    </div>
</div>
`);

class PackWrite {
    constructor(opts) {
        this.l18n = Texter.create(opts.l18n);
        const learnArea = opts.learnArea;
        const self = this;

        const playProgress = new PlayProgressBar(opts.playProgress, this.l18n, `
${PlayProgressBar.createTitleTextElement(this.l18n.get('learnPage.progress.total'))}
${PlayProgressBar.createTitleTextElement(this.l18n.get('learnPage.progress.correct'), 'correctProgress')}
${PlayProgressBar.createTitleTextElement(this.l18n.get('learnPage.progress.wrong'), 'wrongProgress')}
        `);

        const showProgress = (progress) => {
            const count = progress.passed;
            const total = progress.total;

            const percent = total > 0 ? (count / total) : 0;
            playProgress.text = `${progress.passed} / ${progress.total}`;
            playProgress.percent = percent * 100;

            playProgress.setCustomText('correctProgress', progress.correct);
            playProgress.setCustomText('wrongProgress', progress.wrong);
        };

        function showState(state, data) {
            learnArea.find('div[data-panel]').hide();
            learnArea.find('#answerWrite').hide();

            const activePanel = learnArea.find(`div[data-panel=${state}]`)
                .show();

            switch (state) {
                case 'question':
                    const display = learnQuestion.empty().append(QUESTION_TEMPLATE.render(data));
                    fitText(display.find('p[data-fittext], div[data-fittext]'));
                    display.find('img[data-fitimage]').fitImage({show: true});
                    learnArea.find('#answerWrite').show();
                    inputAnswer.val('').focus().trigger('textchange');
                    break;
                case 'wrong' :
                    $('#wrongAnswerExpected').text(data);
                    $('#wrongAnswerActual').text(inputAnswer.val());
                    activePanel.find('button.btn-primary').focus();
                    break;
                case 'skip' :
                    $('#skipAnswerExpected').text(data);
                    activePanel.find('button.btn-primary').focus();
                    break;
                case 'correct':
                    $('#correctAnswerExpected').text(data);
                    activePanel.find('button.btn-primary').focus();
                    break;
            }

        }

        this.cards = opts.cards;

        this.currentIndex = -1;
        this.currentList = [];
        this.current = null;

        this.listener = showState;
        this.progresser = showProgress;
        this.progress = {
            total: this.cards.length,
            passed: 0,
            passedSum: 0,
            correct: 0,
            wrong: 0,

            increment: function () {
                this.passed += 1;
                this.passedSum += 1;
                if (this.passed > this.total) {
                    this.passed = 1;
                }
                self._fireProgress();
            },
            addWrong: function (n) {
                this.wrong += typeof n === 'number' ? n : 1;
                self._fireProgress();
            },
            addCorrect: function (n) {
                this.correct += typeof n === 'number' ? n : 1;
                self._fireProgress();
            }
        };

        learnArea.find('button[data-action=next]').click(this.next.bind(this));
        learnArea.find('button[data-click=giveup]').click(this.skip.bind(this));
        learnArea.find('button[data-action=forceCorrect]').click(this.forceCorrect.bind(this));

        const learnQuestion = learnArea.find('#learnQuestion');
        const inputAnswer = learnArea.find('#learnAnswer');
        const btnGo = learnArea.find('button[data-click=submit]');

        inputAnswer
            .on('textchange', function () {
                btnGo.prop('disabled', $(this).val().trim().length === 0);
            })
            .on('keypress', (e) => {
                if (isEnterEvent(e) && !btnGo.prop('disabled')) {
                    btnGo.click();
                }
            });

        btnGo.click(() => {
            this.answer(inputAnswer.val());
        });

        this.start();
    }

    start() {
        this.progress.passed = 0;
        this._display(this._next());
    }

    _next() {
        this.currentIndex = (this.currentIndex + 1) % this.cards.length;
        if (this.currentIndex === 0) {
            this._shuffle();
        }
        return this.currentList[this.currentIndex];
    }

    _shuffle() {
        let lastLast = null;
        if (this.currentList.length > 0) {
            lastLast = this.currentList[this.currentList.length - 1];
        }

        this.currentList = [];
        for (let i = 0; i < this.cards.length; ++i) {
            this.currentList.push(this.cards[i]);
        }

        shuffleArray(this.currentList);

        if (lastLast !== null && this.currentList.length > 0 && lastLast === this.currentList[0]) {
            swapInArray(this.currentList, 0, this.currentList.length - 1);
        }
    }

    _fireProgress() {
        this.progresser(this.progress);
    }

    _fireState(state, data) {
        this.listener(state, data);
    }

    _getQuestionModel(card) {
        return {
            image: card.backImageSrc,
            text: card.backText
        };
    }

    _getAnswerText(card) {
        return card.faceText;
    }

    _display(card) {
        this.current = card;

        if (card !== null) {
            this._fireState('question', this._getQuestionModel(card));
            this.progress.increment();
        }
    }

    skip() {
        this._fireState('skip', this._getAnswerText(this.current));
    }

    next() {
        this._display(this._next());
    }

    forceCorrect() {
        this.progress.addWrong(-1);
        this.progress.addCorrect();
        this.next();
    }

    answer(val) {
        const answer = val.trim().toLocaleLowerCase();
        const expected = this._getAnswerText(this.current);

        if (answer === expected.toLocaleLowerCase()) {
            this._fireState('correct', expected);
            this.progress.addCorrect();
        } else {
            this._fireState('wrong', expected);
            this.progress.addWrong();
        }
    }
}

global.PackWrite = PackWrite;